'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../components/buttons/Button/index';
import {I18nComponent} from '../../core-utilities/react-i18n/I18nComponent';


export function BaseManageAccessView(props) {
  return (
    <Button
      className={classNames('BaseButton IconButton', props.className)}
      iconClass="icon ion-person-stalker"
      title={props.title}
      onClick={props.onShowManageAccess}
    />
  );
}

BaseManageAccessView.propTypes = {
  title: T.string,
  onShowManageAccess: T.func,
};

export const ManageAccessView = I18nComponent(BaseManageAccessView, [
  {code: 'icon.manageAccess.title', prop: 'title'},
]);



// WEBPACK FOOTER //
// ./src/js/core-components/ManageAccess/ManageAccessView.js